import { render } from "./Heading.vue?vue&type=template&id=28e92538&ts=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"

import "./Heading.vue?vue&type=style&index=0&id=28e92538&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__